<div class="content">
    <h2>Netzzuordnungen</h2>
    <tnb-netzzuordnungen-list></tnb-netzzuordnungen-list>
</div>
